<template>
    <div class="grid grid-cols-2 filter-control">
        <div class="col-span-1 pr-2 pl-2 pt-1">
            <input type="text" id="filter_search" placeholder="Search Products" @keyup="submitFilterDelayed" v-model="query">
        </div>
        <div class="col-span-1">
            <button class="btn-outline btn-clear-filters py-1 px-1" @click.prevent="resetFilters()">Clear Filters</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductsFilter",
    props: {
        timeout_length: {
            type: Number,
            required: false,
            default: 600
        }
    },
    data() {
      return {
          query: null
      }
    },
    methods: {
        submitFilterDelayed() {
            let vm = this;

            clearTimeout(vm.timeout);

            vm.timeout = setTimeout(function() {
                vm.submitFilter();
            }, this.timeout_length);
        },
        submitFilter() {
            const query = this.query;
            this.$emit('submitFilter', query);
        },
        resetFilters() {
            this.query = null;
            this.$emit('resetFilters');
        },
    },
}
</script>
